export default __webpack_public_path__ + "3945f43cff2c3e8b23772a2540fa29de.jpg";